const palette = {
  background: '#FFFFFF',
  backgroundSoft: '#F7FAFF',
  announcementBg: '#E6F0FF',
  announcementText: '#1E2A4A',
  announcementPillBg: '#DDEBFF',
  announcementPillText: '#1C64F2',
  textPrimary: '#0F172A',
  textSecondary: '#5A6072',
  textMuted: '#596579',
  accent: '#509ee3',
  accentHover: '#1C64D6',
  accentSubtle: '#E3EDFF',
  border: '#E5E7EF',
  borderMuted: '#C8D6F8',
  navCaret: '#94A3B8',
  shadow: '0 18px 40px rgba(28,100,242,0.18)'
};

const typography = {
  family: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  sizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '40px',
    xxl: '56px'
  },
  weights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }
};

const spacing = value => `${value * 8}px`;

const radii = {
  sm: '8px',
  md: '10px',
  lg: '16px'
};

const breakpoints = {
  lg: '1280px',
  md: '1024px'
};

const theme = {
  palette,
  typography,
  spacing,
  radii,
  breakpoints,
  containerWidth: '1320px'
};

export default theme;
